import { CodeNode } from '@lexical/code';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { CHECK_LIST, TextMatchTransformer, TRANSFORMERS } from '@lexical/markdown';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { $isTextNode } from 'lexical';

import theme from '../lexical/themes/markdown';
import { PRESERVE_NEWLINES } from './preserve-newlines';
import { TABLE } from './table-transformer';

/**
 * The markdown transformer set, node list, and theme. Kept free of React,
 * Chakra, and DOM imports so the same configuration drives both the editor
 * component and a headless server-side markdown <-> Lexical conversion (see
 * wysiwyg/convert). markdown-editor.tsx re-exports these for existing callers.
 */

// TABLE goes first: it is a multi-line element transformer and must claim pipe
// rows before the inline/text transformers treat them as plain text.
export const MD_SHORTCUT_TRANSFORMERS = [CHECK_LIST, ...TRANSFORMERS];
export const MD_TRANSFORMERS = [TABLE, PRESERVE_NEWLINES, ...MD_SHORTCUT_TRANSFORMERS];

// 0.50 would reload plain `[Docs](url)` as a link; export it as `\[Docs\](url)` instead.
const ESCAPED_BRACKETS: TextMatchTransformer = {
  dependencies: [],
  export: (node, _exportChildren, exportFormat) => {
    if (!$isTextNode(node) || node.hasFormat('code')) {
      return null;
    }

    return exportFormat(node, node.getTextContent()).replace(/[[\]]/g, '\\$&');
  },
  importRegExp: /(?!)/,
  regExp: /(?!)/,
  replace: () => undefined,
  trigger: '\0',
  type: 'text-match',
};

export const MD_EXPORT_TRANSFORMERS = [...MD_TRANSFORMERS, ESCAPED_BRACKETS];

export const MD_NODES = [
  HeadingNode,
  QuoteNode,
  CodeNode,
  ListNode,
  ListItemNode,
  AutoLinkNode,
  LinkNode,
  // The TABLE transformer depends on these nodes during import and export.
  TableNode,
  TableRowNode,
  TableCellNode,
];

export const MD_THEME = theme;
